import { AUTH_ACTIONS } from './authReducer';

// eslint-disable-next-line import/prefer-default-export
export const setAuthLoadingAction = (loading) => ({
  type: AUTH_ACTIONS.setLoading,
  payload: { loading },
});
